import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

// @ts-ignore
import color from "../sass/modules/color.module.scss";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: color.blue600_light,
        blue: color.blue600_light,
        anchor: color.blue500_light,
        info: color.blue500_light
      },
      dark: {
        primary: color.blue600_dark,
        blue: color.blue500_light,
        info: color.blue500_light
      }
    }
  },
  icons: {
    iconfont: "mdiSvg"
  }
});
